// eslint-disable-next-line react/prop-types

import React from "react";
import PropTypes from "prop-types";
import { Button, Tooltip, Dropdown } from "antd";
import {
  DownloadOutlined,
  EyeOutlined,
  HistoryOutlined,
  FileSearchOutlined,
  EllipsisOutlined,
  FormOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

function ProfileCard({
  className = "col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12",
  status = "",
  title = "N/A",
  subtitle = "N/A",
  updatedBy = "N/A",
  createdAt = "--/--/---- --/--",
  updatedAt = "--/--/---- --/--",
  onDownload,
  onView,
  onTimeline,
  onHistory,
  onNote,
  onConfirmComplete,
  maHoSo,
  ShowUC,
}) {
  return (
    <div className={`${className} pb-4 pt-0 d-flex justify-content-start`}>
      <div
        className="bg-white pt-4 pb-3 px-4 shadow-sm w-100 dossier-card"
        style={{
          border: "1px solid #edeff2",
          borderRadius: "16px",
          transition: "box-shadow 0.2s ease",
        }}
      >
        {/* Subtitle */}
        <div className="mb-1" style={{ fontSize: "0.875rem" }}>
          {subtitle} {maHoSo ? `(${maHoSo})` : ""}
        </div>

        {/* Title */}
        <div
          className="font-weight-bold text-uppercase"
          style={{ fontSize: "1rem", lineHeight: 1.3 }}
        >
          {title}
        </div>

        {/* Updated Info */}
        <div className="mt-1" style={{ fontSize: "0.875rem" }}>
          <p
            className="text-truncate"
            style={{ maxWidth: "100%", marginBottom: "1px" }}
          >
            Ngày tạo: {createdAt}
          </p>
          {/* <p
            className="text-truncate"
            style={{ maxWidth: "100%", marginBottom: "1px" }}
          >
            Ngày cập nhật: {updatedAt}
          </p> */}
          <p
            title={updatedBy ? `Cập nhật bởi: ${updatedBy}` : ""}
            className="text-truncate"
            style={{ maxWidth: "100%", marginBottom: "1px" }}
          >
            {updatedBy
              ? `Cập nhật bởi: ${updatedBy}`
              : `Ngày cập nhật: ${updatedAt}`}
          </p>
        </div>

        {/* Status badge */}
        {status}
        {/* <div
          className="mt-2 mb-1 px-3 py-1 d-inline-block"
          style={{
            backgroundColor: colorSet.bg,
            color: colorSet.text,
            fontSize: "0.875rem",
            borderRadius: "0.5rem",
            fontWeight: "600 !important",
          }}
        >
          {statusText}
        </div> */}

        {/* Divider */}
        <hr className="mt-2 mb-2" style={{ borderTop: "1px solid #eee" }} />

        {/* Action buttons - centered */}
        <div className="d-flex flex-wrap justify-content-center gap-2 mt-3 mb-0">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            className="flex-grow-1"
            style={{
              transition: "all 0.2s",
            }}
            onClick={onView}
          >
            Xem hồ sơ
          </Button>

          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            menu={{
              items: [
                ShowUC &&
                  onTimeline && {
                    key: "timeline",
                    label: "Xem tiến trình",
                    icon: <HistoryOutlined />,
                    onClick: onTimeline,
                  },
                ShowUC &&
                  onHistory && {
                    key: "history",
                    label: "Xem lịch sử",
                    icon: <FileSearchOutlined />,
                    onClick: onHistory,
                  },
                ShowUC &&
                  onNote && {
                    key: "note",
                    label: "Tạo ghi chú",
                    icon: <FormOutlined />,
                    onClick: onNote,
                  },
                onDownload && {
                  key: "download",
                  label: "Tải file kết quả",
                  icon: <DownloadOutlined />,
                  onClick: onDownload,
                },
                ShowUC &&
                  onConfirmComplete && {
                    type: "divider",
                  },
                ShowUC &&
                  onConfirmComplete && {
                    key: "confirmComplete",
                    label: "Xác nhận kết quả",
                    icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
                    onClick: onConfirmComplete,
                  },
              ].filter(Boolean),
            }}
          >
            <Button
              type="primary"
              // shape="circle"
              icon={<EllipsisOutlined />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

ProfileCard.propTypes = {
  className: PropTypes.string,
  statusText: PropTypes.string,
  statusColor: PropTypes.oneOf([0, 1, 2, 3, 4]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  updatedBy: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  onDownload: PropTypes.func,
  onView: PropTypes.func,
  onTimeline: PropTypes.func,
  onHistory: PropTypes.func,
  onNote: PropTypes.func,
};

export default ProfileCard;
